import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AlertModule } from '@epicuro-next/ataraxia/alert';
import { DomSanitizerModule } from '@epicuro-next/ataraxia/dom-sanitizer';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { LanguageSelectorModule } from '@epicuro-next/ataraxia/language-selector';
import { ModalModule } from '@epicuro-next/ataraxia/modal';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';
import { DataMerchandiseModule } from '@epicuro-next/data/merchandise';
import { APP_AUTH_LEVEL_PATH } from '@epicuro-next/navigation/constants';
import {
  AuthenticationModule,
  LoginPageGuard,
} from '@epicuro-next/platform/authentication';

import { AuthBackdropComponent } from './components/backdrop/backdrop.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { LoginComponent } from './components/login/login.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SupportComponent } from './components/support/support.component';
import { AuthTermsComponent } from './components/terms/terms.component';
import { AuthComponent } from './containers/auth-page/auth-page.component';

@NgModule({
  imports: [
    CommonModule,
    DataMerchandiseModule,
    IconsModule,
    ReactiveFormsModule,
    RouterModule.forChild([
      {
        path: '',
        component: AuthComponent,
        canActivate: [LoginPageGuard],
        children: [
          {
            path: APP_AUTH_LEVEL_PATH.login.path,
            component: LoginComponent,
          },
          {
            path: APP_AUTH_LEVEL_PATH.forgotPassword.path,
            component: ForgotPasswordComponent,
          },
          {
            path: APP_AUTH_LEVEL_PATH.resetPassword.path,
            component: ResetPasswordComponent,
          },
          {
            path: APP_AUTH_LEVEL_PATH.welcome.path,
            component: ResetPasswordComponent,
          },
        ],
      },
    ]),
    ModalModule,
    LanguageSelectorModule,
    DomSanitizerModule,
    AuthenticationModule,
    TooltipDirective,
    AlertModule,
  ],
  declarations: [
    AuthComponent,
    LoginComponent,
    AuthBackdropComponent,
    AuthTermsComponent,
    SupportComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
  ],
})
export class AuthenticationUIModule {}
